import React from "react";
import { GlobalProvider } from "./global";
import { ApiProvider } from "./api";
import { WalletProvider } from "./wallet";

const AppProvider: React.FC = ({ children }) => {
  return (
    <GlobalProvider>
      <ApiProvider>
        <WalletProvider>
          {children}
        </WalletProvider>
      </ApiProvider>
    </GlobalProvider>
  );
};

export default AppProvider;
